/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateUpdateSurveyAnswerDto } from './CreateUpdateSurveyAnswerDto';
import {
    CreateUpdateSurveyAnswerDtoFromJSON,
    CreateUpdateSurveyAnswerDtoFromJSONTyped,
    CreateUpdateSurveyAnswerDtoToJSON,
} from './CreateUpdateSurveyAnswerDto';

/**
 * 
 * @export
 * @interface SubmitAnswersDto
 */
export interface SubmitAnswersDto {
    /**
     * 
     * @type {Array<CreateUpdateSurveyAnswerDto>}
     * @memberof SubmitAnswersDto
     */
    answers: Array<CreateUpdateSurveyAnswerDto>;
    /**
     * 
     * @type {string}
     * @memberof SubmitAnswersDto
     */
    surveyId: string;
}

/**
 * Check if a given object implements the SubmitAnswersDto interface.
 */
export function instanceOfSubmitAnswersDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "answers" in value;
    isInstance = isInstance && "surveyId" in value;

    return isInstance;
}

export function SubmitAnswersDtoFromJSON(json: any): SubmitAnswersDto {
    return SubmitAnswersDtoFromJSONTyped(json, false);
}

export function SubmitAnswersDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitAnswersDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'answers': ((json['answers'] as Array<any>).map(CreateUpdateSurveyAnswerDtoFromJSON)),
        'surveyId': json['surveyId'],
    };
}

export function SubmitAnswersDtoToJSON(value?: SubmitAnswersDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'answers': ((value.answers as Array<any>).map(CreateUpdateSurveyAnswerDtoToJSON)),
        'surveyId': value.surveyId,
    };
}

